import { render, staticRenderFns } from "./ClientGeneral.vue?vue&type=template&id=34e38a6e"
import script from "./ClientGeneral.vue?vue&type=script&lang=ts"
export * from "./ClientGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports